import { faqApi } from "../config/faq";

export const getFaqs = () => {
    return faqApi.getFaqs().then(response => response);
};

export const rateFaq = (id, useful) => {
    return faqApi.rateFaq(id, useful).then(response => response);
};
